module.exports = __webpack_public_path__ + "static/img/tu8.93584ee6.png";